<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="stat-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 顶部搜索栏（折叠版） -->
        <div class="search-bar">
          <!-- 折叠/展开按钮 -->
          <el-button
            icon="el-icon-arrow-down"
            type="text"
            @click="toggleSearch"
            style="margin-right: 10px"
          >
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </el-button>
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }"
          >
            <!-- 用户ID筛选 -->
            <el-input
              v-model="searchParams.user_id"
              placeholder="请输入用户ID"
              style="width: 180px"
              clearable
            ></el-input>
            <!-- 日期筛选 -->
            <el-date-picker
              v-model="searchParams.sys_date"
              type="date"
              placeholder="选择统计日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
              clearable
            >
            </el-date-picker>
          </div>
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button type="primary" icon="el-icon-search" @click="getStatList"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" @click="resetSearch"
              >重置</el-button
            >
            <!-- 列筛选 -->
            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="260"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                >
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>
        </div>

        <!-- 统计表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column
            label="ID"
            prop="id"
            width="80"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="100"
            align="center"
            v-if="checkedColumns.includes('user_id')"
          />
          <el-table-column
            label="用户编号"
            prop="user_no"
            min-width="160"
            align="center"
            v-if="checkedColumns.includes('user_no')"
          />
          <el-table-column
            label="昵称"
            prop="nickname"
            min-width="120"
            align="center"
            v-if="checkedColumns.includes('nickname')"
          >
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;gap:6px;">
                <el-avatar :src="scope.row.avatar" size="32"></el-avatar>
                <span>{{ scope.row.nickname }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="统计日期"
            prop="sys_date"
            width="120"
            align="center"
            v-if="checkedColumns.includes('sys_date')"
          />
          <el-table-column
            label="统计时间"
            prop="sys_time"
            width="100"
            align="center"
            v-if="checkedColumns.includes('sys_time')"
          />
          <el-table-column
            label="奖品总价值"
            prop="prize_price"
            width="120"
            align="center"
            v-if="checkedColumns.includes('prize_price')"
          >
            <template slot-scope="scope">¥{{ scope.row.prize_price }}</template>
          </el-table-column>
          <el-table-column
            label="金币"
            prop="balance"
            width="120"
            align="center"
            v-if="checkedColumns.includes('balance')"
          >
            <template slot-scope="scope">¥{{ scope.row.balance }}</template>
          </el-table-column>
          <el-table-column
            label="钻石"
            prop="point"
            width="100"
            align="center"
            v-if="checkedColumns.includes('point')"
          />
          <el-table-column
            label="无限币"
            prop="blind_point"
            width="120"
            align="center"
            v-if="checkedColumns.includes('blind_point')"
          />
          <el-table-column
            label="闯关币"
            prop="challenge_point"
            width="100"
            align="center"
            v-if="checkedColumns.includes('challenge_point')"
          />
          <el-table-column
            label="PK币"
            prop="pk_point"
            width="100"
            align="center"
            v-if="checkedColumns.includes('pk_point')"
          />
          <el-table-column
            label="擂台币"
            prop="fight_point"
            width="100"
            align="center"
            v-if="checkedColumns.includes('fight_point')"
          />
          <el-table-column
            label="创建时间"
            prop="created_at"
            min-width="170"
            align="center"
            v-if="checkedColumns.includes('created_at')"
          />
          <el-table-column
            label="更新时间"
            prop="updated_at"
            min-width="170"
            align="center"
            v-if="checkedColumns.includes('updated_at')"
          />
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        >
        </el-pagination>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-stat-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 搜索 -->
        <div class="mobile-search-group">
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="toggleSearch"
            style="width: 100%; text-align: left; padding-left: 0"
          >
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </el-button>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="请输入用户ID"
              clearable
            ></el-input>
            <el-date-picker
              v-model="searchParams.sys_date"
              type="date"
              placeholder="选择统计日期"
              value-format="yyyy-MM-dd"
              size="medium"
              clearable
            >
            </el-date-picker>
          </div>
        </div>
        <div style="display: flex; gap: 8px; margin-bottom: 10px">
          <el-button
            type="primary"
            plain
            round
            @click="getStatList"
            style="flex: 1"
            >搜索</el-button
          >
          <el-button plain round @click="resetSearch" style="flex: 1"
            >重置</el-button
          >
        </div>

        <!-- 统计卡片列表 -->
        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <div class="info" style="display:flex;align-items:center;gap:10px;">
                <el-avatar :src="item.avatar" size="44"></el-avatar>
                <div>
                  <div class="title">
                    {{ item.nickname }}
                  </div>
                  <div class="sub-title">ID：{{ item.user_id }} | 用户编号：{{ item.user_no }}</div>
                </div>
              </div>
              <div style="margin-top:6px;font-size:13px;color:#888;">
                统计时间：{{ item.sys_date }} {{ item.sys_time }}
              </div>
            </div>
            <div class="card-body">
              <div>
                奖品总价值：<span class="highlight"
                  >¥{{ item.prize_price }}</span
                >
              </div>
              <div>
                金币：<span class="highlight">¥{{ item.balance }}</span>
              </div>
              <div>
                钻石：{{ item.point }} | 无限币：{{ item.blind_point }}
              </div>
              <div>
                闯关币：{{ item.challenge_point }} | PK币：{{ item.pk_point }} |
                擂台币：{{ item.fight_point }}
              </div>
              <div style="margin-top:4px;font-size:12px;color:#999;">
                创建：{{ item.created_at }}
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "UserStatistical",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      // 搜索参数
      searchParams: {
        page: 1,
        page_size: 10,
        sys_date: "",
        user_id: ""
      },
      // 表格列配置
      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "用户ID", prop: "user_id" },
        { label: "用户编号", prop: "user_no" },
        { label: "昵称", prop: "nickname" },
        { label: "统计日期", prop: "sys_date" },
        { label: "统计时间", prop: "sys_time" },
        { label: "奖品总价值", prop: "prize_price" },
        { label: "金币", prop: "balance" },
        { label: "钻石", prop: "point" },
        { label: "无限币", prop: "blind_point" },
        { label: "闯关币", prop: "challenge_point" },
        { label: "PK币", prop: "pk_point" },
        { label: "擂台币", prop: "fight_point" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新时间", prop: "updated_at" }
      ],
      // 默认全选列
      checkedColumns: [
        "id",
        "user_id",
        "user_no",
        "nickname",
        "sys_date",
        "sys_time",
        "prize_price",
        "balance",
        "point",
        "blind_point",
        "challenge_point",
        "pk_point",
        "fight_point",
        "created_at"
      ],
      searchCollapsed: true,
    };
  },
  created() {
    this.getStatList();
  },
  methods: {
    // 获取用户统计数据
    async getStatList() {
      this.loading = true;
      try {
        const res = await api.loss.getUserStatistical({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data || [];
          this.pageInfo.total = res.data.data.total || 0;
        }
      } finally {
        this.loading = false;
      }
    },
    // 重置搜索
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        sys_date: "",
        user_id: ""
      };
      this.getStatList();
    },
    // 每页条数切换
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getStatList();
    },
    // 页码切换
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getStatList();
    },
    // 全选列
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    // 清空列选择
    handleClearAll() {
      this.checkedColumns = [];
    },
    // 折叠/展开搜索栏
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
  },
};
</script>

<style scoped>
/* PC样式 */
.stat-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端样式 */
.mobile-stat-container {
  padding: 12px;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  margin-bottom: 10px;
}
.info .title {
  font-size: 16px;
  font-weight: 500;
}
.info .sub-title {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}
.highlight {
  color: #f56c6c;
  font-weight: 500;
}
</style>

<style>
/* 响应式布局 */
@media (max-width: 768px) {
  .pc-version {
    display: none !important;
  }
  .mobile-version {
    display: block !important;
  }
}
@media (min-width: 769px) {
  .pc-version {
    display: block !important;
  }
  .mobile-version {
    display: none !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/loss/usersData.vue